import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getColoresPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`col_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';

    return await getData("/colores", queryString);
};

export const getXColor = async (searchTerm) => {
    return await getData("/colores", `?col_descripcion=${searchTerm}`);
};

export const getColorById = async (id) => {
    const res = await getData(`/colores/${id}`)
    return res
}

export const postColor = async (body) => {
    const res = await postData('/colores', body)
    return res
}

export const patchColor = async (id, body) => {
    const res = await patchData(`/colores/${id}`, body)
    return res
}

export const deleteColor = async (id) => {
    const res = await deleteData(`/colores/${id}`)
    return res
}